"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateRatesArea = void 0;
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const L = require("leaflet");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/admin/classes/models");
const gs_1 = require("@ivanlog/gs");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
const StateRatesAreas_1 = require("./StateRatesAreas");
class StateRatesArea extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageRatesArea, "Rates area", true);
        this._points = [];
        this.page.ctrls.btnSave.onclick = () => this.trySave();
        this.page.ctrls.btnSave.hide();
        this.page.ctrls.btnToggleDeleted.hide();
        this.page.ctrls.btnToggleDeleted.onclick = () => this._toggleDeleted();
        if (this.page.ctrls.btnDelete) {
            this.page.ctrls.btnDelete.hide();
            this.page.ctrls.btnDelete.onclick = () => this._toggleDeleted({ redirect: true });
        }
        if (this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl)) {
            this.page.ctrls.btnSave.show();
            this.page.ctrls.btnClear.onclick = () => this._resetPoints();
        }
        else {
            this.page.ctrls.btnToggleDeleted.hide();
            if (this.page.ctrls.btnDelete)
                this.page.ctrls.btnDelete.hide();
        }
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (args) {
                if (args instanceof models_1.RateArea)
                    this._area = args;
                else if (args.id) {
                    this._area = yield this.app.astra.getRateArea(args.id);
                    if (!this._area)
                        return gs_1.StateRunResultEnum.Failed;
                }
            }
            if (this._area)
                this._urlArgs["id"] = this._area.id.toString();
            yield this.fill();
            return _super.start.call(this);
        });
    }
    fill() {
        return __awaiter(this, void 0, void 0, function* () {
            var ctrl = this.page.ctrls;
            if (this._area) {
                this.page.ctrls.btnClear.hide();
                this.page.ctrls.btnSave.hide();
                yield ctrl.form.fillFormData(this._area, true);
                ctrl.iName.addClass("no-active");
                this._setIsDeletedControl(Boolean(this._area.isDeleted));
                this._updateToggleDeletedButton();
                if (this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl)) {
                    this.page.ctrls.btnToggleDeleted.show();
                    if (this.page.ctrls.btnDelete)
                        this.page.ctrls.btnDelete.show();
                }
                else {
                    this.page.ctrls.btnToggleDeleted.hide();
                    if (this.page.ctrls.btnDelete)
                        this.page.ctrls.btnDelete.hide();
                }
                this.page.ctrls.chIsDeleted.el.disabled = true;
                this._updateDeleteButton();
            }
            else {
                this.page.ctrls.btnToggleDeleted.hide();
                if (this.page.ctrls.btnDelete)
                    this.page.ctrls.btnDelete.hide();
                this._setIsDeletedControl(false);
                this.page.ctrls.chIsDeleted.el.disabled = true;
            }
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            if (this._area)
                this.setLabel(this.title + ` #${this._area.id}`);
            this._initMap();
        });
    }
    _initMap() {
        this._map = L.map("map").setView([48.142723, 11.576843], 10);
        var tiles = L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(this._map);
        if (this._area) {
            this._points = [];
            for (const c of this._area.polygon)
                this._points.push(new L.LatLng(c.lat, c.lng));
            this._polygon = L.polygon(this._points).addTo(this._map);
        }
        else {
            this._map.on("click", (ev) => {
                let e = ev;
                this._points.push(e.latlng);
                this._polygon.addLatLng(e.latlng);
            });
            this._resetPoints();
        }
    }
    _resetPoints() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._polygon)
                this._polygon.removeFrom(this._map);
            this._polygon = L.polygon([]).addTo(this._map);
            this._points = [];
        });
    }
    trySave() {
        return __awaiter(this, void 0, void 0, function* () {
            var data = yield this.page.ctrls.form.getFormData();
            if (!data)
                return;
            let area;
            const req = new models_1.CreateRateAreaRequest(data);
            req.coordinates = [];
            for (const p of this._points)
                req.coordinates.push(new models_1.Coordinates(p));
            area = yield this.lockgui(this.app.api.admin.directory.createRateArea(req));
            if (!area)
                return;
            yield new modalCom.DialogOk("Rate area created").show();
            yield gs_1.StateGS.Run(StateRatesAreas_1.StateRatesAreas);
        });
    }
    _setIsDeletedControl(value) {
        this.page.ctrls.chIsDeleted.el.checked = value;
        this.page.ctrls.chIsDeleted.el.value = value ? "true" : "false";
    }
    _updateToggleDeletedButton() {
        const button = this.page.ctrls.btnToggleDeleted;
        if (!button)
            return;
        const desiredState = this._area ? !this._area.isDeleted : false;
        button.el.title = desiredState ? "Mark area as deleted" : "Restore area";
    }
    _toggleDeleted() {
        return __awaiter(this, arguments, void 0, function* (options = {}) {
            if (!this._area)
                return;
            if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl))
                return;
            yield this._deleteOrRestore(options.redirect === true);
        });
    }
    _deleteOrRestore(redirect) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._area)
                return;
            if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl))
                return;
            if (!this._area.isDeleted) {
                const response = yield this.lockgui(this.app.api.admin.directory.deleteRateArea(this._area.id));
                if (!response)
                    return;
                this._area.isDeleted = true;
                this._setIsDeletedControl(true);
                this._updateToggleDeletedButton();
                this._updateDeleteButton();
                yield this.app.astra.refreshRateAreas();
                if (redirect) {
                    yield new modalCom.DialogOk("Rate area deleted").show();
                    yield gs_1.StateGS.Run(StateRatesAreas_1.StateRatesAreas);
                }
                else {
                    yield new modalCom.DialogOk("Rate area marked as deleted").show();
                }
                return;
            }
            const restored = yield this.lockgui(this.app.api.admin.directory.restoreRateArea(this._area.id));
            if (!restored)
                return;
            this._area = restored;
            this._setIsDeletedControl(Boolean(this._area.isDeleted));
            this._updateToggleDeletedButton();
            this._updateDeleteButton();
            yield this.app.astra.refreshRateAreas();
            if (redirect) {
                yield new modalCom.DialogOk("Rate area restored").show();
                yield gs_1.StateGS.Run(StateRatesAreas_1.StateRatesAreas);
            }
            else {
                yield new modalCom.DialogOk("Rate area restored").show();
            }
        });
    }
    _updateDeleteButton() {
        const btn = this.page.ctrls.btnDelete;
        if (!btn)
            return;
        if (!this._area || !this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl)) {
            btn.hide();
            return;
        }
        const isDeleted = Boolean(this._area.isDeleted);
        btn.el.title = isDeleted ? "Restore area" : "Delete area";
        btn.show();
    }
}
exports.StateRatesArea = StateRatesArea;
StateRatesArea.StateName = "ratesArea";
//# sourceMappingURL=StateRatesArea.js.map